import { Directive, Inject } from '@angular/core';
import { LIST_CONTAINER_DATA } from '@fi-app/components/items-list/list-data.service';

@Directive()
export abstract class ItemListContainerBase {
    constructor(@Inject(LIST_CONTAINER_DATA) data) {
        Object.assign(this, data);
    }
}
